/**
 * Delivery Method Selection Handler - NO RELOAD VERSION
 * Stores delivery method in line item properties (which ARE sent to carrier service)
 */

(function() {
  'use strict';
  
  /**
   * Add delivery method property to ALL items in cart
   */
  async function updateAllItemsWithDeliveryMethod(deliveryMethod) {
    try {
      console.log('Updating all items with delivery method:', deliveryMethod);
      
      // Get current cart
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      if (!cart.items || cart.items.length === 0) {
        console.log('Cart is empty');
        return;
      }
      
      console.log('Found', cart.items.length, 'items in cart');
      
      // Update each item individually
      for (let i = 0; i < cart.items.length; i++) {
        const item = cart.items[i];
        
        // Skip if this is already a delivery fee item
        if (item.properties && item.properties._adjustment_type === 'delivery') {
          console.log('Skipping delivery fee item:', item.title);
          continue;
        }
        
        // Get existing properties
        const existingProps = item.properties || {};
        
        // Add/update delivery method property
        const newProps = {
          ...existingProps,
          '_delivery_method': deliveryMethod
        };
        
        console.log('Updating item', (i + 1) + ':', item.title, 'with properties:', newProps);
        
        // Update using line number (1-based index)
        const updateResponse = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            line: i + 1,  // Line numbers are 1-based
            quantity: item.quantity,
            properties: newProps
          })
        });
        
        if (!updateResponse.ok) {
          const errorText = await updateResponse.text();
          console.error('Failed to update item:', errorText);
          throw new Error('Failed to update item ' + item.title);
        }
        
        console.log('Successfully updated item', (i + 1));
      }
      
      // Get fresh cart after all updates
      const finalCartResponse = await fetch('/cart.js');
      const updatedCart = await finalCartResponse.json();
      console.log('All items updated successfully. Final cart:', updatedCart);
      
      // Also update cart note and attributes as backup
      console.log('Updating cart note and attributes to:', deliveryMethod);
      const noteUpdateResponse = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          note: `Delivery:${deliveryMethod}`,
          attributes: {
            'delivery_method': deliveryMethod,
            '_delivery_method': deliveryMethod
          }
        })
      });
      
      if (!noteUpdateResponse.ok) {
        console.error('Failed to update cart note/attributes');
      } else {
        const finalCart = await noteUpdateResponse.json();
        console.log('Cart note and attributes updated. Final cart:', finalCart);
      }
      
      return updatedCart;
      
    } catch (error) {
      console.error('Error updating items:', error);
      throw error;
    }
  }
  
  /**
   * Handle delivery fee line item based on selection
   */
  async function handleDeliveryFeeLineItem(deliveryMethod) {
    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      // Find existing delivery fee item
      const deliveryFeeItem = cart.items.find(item => 
        item.properties && item.properties._adjustment_type === 'delivery'
      );
      
      if (deliveryMethod === 'delivery') {
        console.log('Delivery selected - delivery fee will be added at checkout');
        // Don't add here - let your existing checkout script handle it
      } else {
        // Pickup selected - remove delivery fee if it exists
        if (deliveryFeeItem) {
          console.log('Removing delivery fee item');
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: deliveryFeeItem.key,
              quantity: 0
            })
          });
        }
      }
    } catch (error) {
      console.error('Error handling delivery fee:', error);
    }
  }
  
  /**
   * Update delivery method
   */
  async function updateDeliveryMethod(deliveryMethod) {
    try {
      console.log('=== Starting delivery method update ===');
      console.log('Selected method:', deliveryMethod);
      
      // Step 1: Update all line items with the delivery method property
      await updateAllItemsWithDeliveryMethod(deliveryMethod);
      
      // Step 2: Handle delivery fee line item
      await handleDeliveryFeeLineItem(deliveryMethod);
      
      // Step 3: Save to session (as backup)
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      const identifier = cart.token || 'guest_' + Date.now();
      
      await fetch('https://waml.in/api/set_delivery_method.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          identifier: identifier,
          delivery_method: deliveryMethod
        })
      });
      
      console.log('=== Delivery method update complete ===');
      
      // Trigger event
      document.dispatchEvent(new CustomEvent('deliveryMethodUpdated', {
        detail: { method: deliveryMethod }
      }));
      
      return true;
      
    } catch (error) {
      console.error('Error updating delivery method:', error);
      throw error;
    }
  }
  
  /**
   * Initialize delivery method selector
   */
  function initDeliveryMethodSelector() {
    const deliveryInputs = document.querySelectorAll('[name="delivery_method"], [data-delivery-method]');
    
    if (deliveryInputs.length === 0) {
      console.warn('No delivery method inputs found');
      return;
    }
    
    console.log('Found', deliveryInputs.length, 'delivery method inputs');
    
    deliveryInputs.forEach(input => {
      input.addEventListener('change', async function(e) {
        const selectedMethod = e.target.value || e.target.dataset.deliveryMethod;
        
        console.log('Delivery method changed to:', selectedMethod);
        
        // Show loading
        const form = e.target.closest('form');
        if (form) {
          form.classList.add('loading');
        }
        
        try {
          await updateDeliveryMethod(selectedMethod);
          
          showNotification('Delivery method updated successfully!', 'success');
          
          
          // NO RELOAD - just remove loading state
          if (form) {
            form.classList.remove('loading');
          }
          
        } catch (error) {
          //showNotification('Failed to update delivery method', 'error');
          
          if (form) {
            form.classList.remove('loading');
          }
        }
      });
    });
    
    console.log('Delivery method selector initialized');
  }
  
  /**
   * Show notification
   */
  function showNotification(message, type = 'info') {
    console.log(`[${type.toUpperCase()}] ${message}`);
    
    const notification = document.createElement('div');
    notification.className = `delivery-notification delivery-notification--${type}`;
    notification.textContent = message;
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      padding: 15px 20px;
      background: ${type === 'success' ? '#4CAF50' : '#f44336'};
      color: white;
      border-radius: 4px;
      z-index: 9999;
      box-shadow: 0 2px 8px rgba(0,0,0,0.2);
    `;
    
    document.body.appendChild(notification);
    
    setTimeout(() => {
      notification.style.opacity = '0';
      notification.style.transition = 'opacity 0.3s';
      setTimeout(() => notification.remove(), 300);
    }, 3000);
  }
  
  /**
   * Get current delivery method from first item
   */
  async function getCurrentDeliveryMethod() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      if (cart.items && cart.items.length > 0) {
        // Check first non-delivery-fee item
        const firstItem = cart.items.find(item => 
          !item.properties || item.properties._adjustment_type !== 'delivery'
        );
        
        if (firstItem && firstItem.properties && firstItem.properties._delivery_method) {
          console.log('Current delivery method:', firstItem.properties._delivery_method);
          return firstItem.properties._delivery_method;
        }
      }
      
      // Fallback to cart attributes
      return cart.attributes?.delivery_method || '';
    } catch (error) {
      console.error('Error fetching delivery method:', error);
      return '';
    }
  }
  
  /**
   * Pre-select delivery method
   */
  async function preselectDeliveryMethod() {
    const currentMethod = await getCurrentDeliveryMethod();
    
    if (currentMethod) {
      console.log('Pre-selecting delivery method:', currentMethod);
      
      const inputs = document.querySelectorAll(`[name="delivery_method"][value="${currentMethod}"], [data-delivery-method="${currentMethod}"]`);
      inputs.forEach(input => {
        if (input.type === 'radio' || input.type === 'checkbox') {
          input.checked = true;
        } else if (input.tagName === 'SELECT') {
          input.value = currentMethod;
        }
      });
    }
  }
  
  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initDeliveryMethodSelector();
      preselectDeliveryMethod();
    });
  } else {
    initDeliveryMethodSelector();
    preselectDeliveryMethod();
  }
  
  // Expose globally
  window.DeliveryMethodHandler = {
    updateDeliveryMethod,
    getCurrentDeliveryMethod,
    updateAllItemsWithDeliveryMethod
  };
  
})();